<div class="input-wrapper">
  <!-- Label -->
  <label *ngIf="label" class="label" [for]="inputId">
    {{ label }}
    <span *ngIf="errorMessage['required']" class="text-required">*</span>
  </label>

  <!-- Field Wrapper -->
  <div class="input-field-wrapper">
    <!-- Search Icon (Left) -->
    <span
      *ngIf="isSearch"
      class="search-icon"
      [innerHTML]="searchIcon | safeHtml"
    ></span>
    <span *ngIf="prefixText" class="prefix-text">{{ prefixText }}</span>
    <!-- Input Modes -->
    <ng-container *ngIf="!isModeAutocomplete">
      <input
        class="input-field input-field-medium"
        [type]="
          inputType === 'password'
            ? showPassword
              ? 'text'
              : 'password'
            : 'text'
        "
        [disabled]="disabled"
        [value]="value"
        [placeholder]="placeholder"
        [ngClass]="{
          'input-has-error': isInvalid,
          'input-with-search': isSearch,
          'input-with-prefix': !!prefixText,
        }"
        [ngStyle]="{ height: height }"
        [readOnly]="isReadonly"
        [autocomplete]="
          autocomplete ?? (inputType === 'password' ? 'on' : 'off')
        "
        (input)="onInputChange($event)"
        (focus)="onInputFocus()"
      />
    </ng-container>

    <!-- Autocomplete -->
    <ng-container *ngIf="isModeAutocomplete">
      <input
        #placesRef="ngx-places"
        class="input-field input-field-medium"
        type="text"
        ngx-google-address-autocomplete
        [options]="addressOptionCountry"
        [value]="value"
        [placeholder]="placeholder"
        [ngClass]="{
          'input-has-error': isInvalid,
          'input-with-search': isSearch,
          'input-with-prefix': !!prefixText,
        }"
        [ngStyle]="{ height: height }"
        (input)="onInputChange($event)"
        (focus)="onInputFocus()"
      />
    </ng-container>

    <!-- Password Toggle (Eye icon) -->
    <button
      *ngIf="inputType === 'password'"
      type="button"
      class="btn-password-toggle"
      [attr.aria-pressed]="showPassword"
      (click)="togglePasswordVisibility()"
    >
      <i class="fas" [ngClass]="showPassword ? 'fa-eye' : 'fa-eye-slash'"></i>
    </button>

    <!-- Clear X Button (Search only) -->
    <button
      *ngIf="isSearch && value"
      type="button"
      class="clear-btn"
      aria-label="Clear search"
      (click)="clearInput()"
    >
      &times;
    </button>
  </div>

  <!-- Helper Message Slot -->
  <ng-content select=".helper-message" />

  <!-- Validation Error Message -->
  <span class="error-msg">
    {{ getErrorMessage() }}
  </span>

  <!-- Extra content slot -->
  <ng-content />
</div>
